import axios from "axios"
import ContentBody from "../../../../network/common/content-body/ContentBody"
import { ServerSideTypes } from "../../common/OperationCommonTypes"

export const VehicleToBeRepairedService ={
    get:{
        getStatus:(tenanta:string)=>{
            return axios.get<any>("./masterdatadamage/damageform/repairstatus",{params:{tenants:tenanta}}).then(
                response=>response.data
            )
           },
           getStatausList:(tenants:string,data:any,serverSide:ServerSideTypes.IParams)=>{
            return axios.get<any>("./masterdatadamage/damageform/repairstatus/list",{params:{tenants,...data,...serverSide}}).then(response=>response.data)
           },
           export:(tenants:string,data:any)=>{
            return axios.get<any>("./masterdatadamage/damageform/repairstatus/list/excel",{params:{tenants,...data},responseType:"arraybuffer"})
           },
           getRepairStatus:(tenants:string,damageFormId :number)=>{
            let content:any =[];
           return  axios.get<any>(`./masterdatadamage/damageform/repairstatus/details/${damageFormId}`,{params:{tenants:tenants}}).then(response=>
            Object.entries(response.data).map(([k, v]) => ({ [k]: v })).map((eqp: any) => ({ 
                status: `${Object.keys(eqp)}`,
                statusData: `${Object.values(eqp)}`,
            })
            ),
            )
            
           }
    }
}
